module.exports = __webpack_public_path__ + "dingbeauty-landing/img/icon_stored.634fde2a.svg";